<!-- begin:: Footer -->
<div class="footer bg-white py-4 d-flex flex-lg-column" id="kt_footer" [ngClass]="footerClasses" [style.z-index]="100">
	<div [ngClass]="footerContainerClasses" class="d-flex flex-column flex-md-row
		align-items-center justify-content-between">
		<!--begin::Copyright-->
		<div class="text-dark order-2 order-md-1">
			<span class="text-muted font-weight-bold mr-2">{{today | date:'yyyy'}} &copy;</span>
			<p class="text-dark-75">7edu - {{'MENU.FINANCIAL' | translate}} - Versão
				{{version}}</p>
		</div>
		<!--end::Copyright-->

		<!--begin::Nav-->
		<div class="nav nav-dark order-1 order-md-2">
			<!-- <a href="http://keenthemes.com/metronic" target="_blank" class="nav-link pr-3 pl-0">About</a>
			<a href="http://keenthemes.com/metronic" target="_blank" class="nav-link px-3">Team</a> -->
			<a target="_blank" class="nav-link pl-3 pr-0 text-hover-danger">
				<mat-icon>bug_report</mat-icon>
			</a>
		</div>
	</div>
</div>
<!-- end:: Footer -->